import { refLoad } from './simple.store';
import { checkStoreStatus } from '@/util/util';
import { List } from 'immutable';
import store from '@/store/store';


export function getSimpleWrapper(refName, refPath, id) {
  if (!id) {
    return undefined;
  }
  checkStoreStatus(refName, refPath, refLoad, 'INF');
  return store
    .getState()
    .getIn(['references', 'simple', refPath], new List())
    .find(ref => ref.get('id') == id);
}

export function getSimpleListWrapper(refName, refPath) {
  if (!checkStoreStatus(refName, refPath, refLoad, 'INF')) {
    return undefined;
  }
  return store
    .getState()
    .getIn(['references', 'simple', refPath]);
}
export function getSimpleSelectWrapper(refName, refPath) {
  if (!checkStoreStatus(refName, refPath, refLoad, 'INF')) {
    return undefined;
  }
  return store
    .getState()
    .getIn(['references', 'simple', refPath], new List())
    .toJS().
    map((elem) => ({ value: elem.id, label: elem.name }));
}
